import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  UserDefaultSettingsData,
  UserDefaultSettingsRequest,
} from "../types/UserDefaultSettings";

const baseUrl = "/api/UserDefaultSettings";

export const getUserDefaultSettings = async (
  addressSystemId: number,
): Promise<UserDefaultSettingsData> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get<UserDefaultSettingsData>(
    `${baseUrl}/${addressSystemId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

export const updateUserDefaultSettings = async (
  addressSystemId: number,
  request: UserDefaultSettingsRequest,
): Promise<void> => {
  const token = await getApiAccessToken();
  await apiClient.post(`${baseUrl}/${addressSystemId}`, request, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
